module.exports = __webpack_public_path__ + "img/14-2.ea8e51c8.png";